import { Icon } from '@iconify/react'
import { useCallback, useState, type ReactNode } from 'react'

import styles from './payment-method.module.scss'

type Props = {
  icon: string
  title: string
  hint?: string
  badgeCount?: number
  defaultOpen?: boolean
  children: ReactNode
}

export const PaymentMethod = ({
  icon,
  title,
  hint,
  badgeCount = 0,
  defaultOpen = false,
  children,
}: Props) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const toggleOpen = useCallback(() => setIsOpen((prev) => !prev), [])

  return (
    <div className={styles.method}>
      <button type='button' className={styles.header} onClick={toggleOpen} aria-expanded={isOpen}>
        <span className={styles.iconBox}>
          <Icon icon={icon} />
        </span>
        <span className={styles.titleWrap}>
          <span className={styles.title}>{title}</span>
          {hint && <span className={styles.hint}>{hint}</span>}
        </span>
        {badgeCount > 0 && <span className={styles.badge}>{badgeCount}</span>}
        <Icon
          icon='ph:caret-right'
          className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
        />
      </button>
      {isOpen && <div className={styles.body}>{children}</div>}
    </div>
  )
}
